import { Helmet } from 'react-helmet-async';
import { capitalizeFirstLetter } from '@/utils/helpers';
import { useLocation, useParams } from 'react-router-dom';

interface HelmetWrapperProps {
  customTitle?: string;
}

const HelmetWrapper = ({ customTitle }: HelmetWrapperProps) => {
  const location = useLocation();
  const params = useParams();

  const generateTitleFromPath = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const formattedSegments = pathSegments.map((segment) => {
      const paramKey = Object.keys(params).find((key) => params[key] === segment);

      if (paramKey && customTitle) {
        return customTitle;
      }
      if (segment === 'edit') {
        return 'Edit';
      }
      return capitalizeFirstLetter(segment);
    });

    const reversedSegments = formattedSegments.reverse();

    return reversedSegments.join(' - ') || 'Home';
  };

  const title = generateTitleFromPath();

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export default HelmetWrapper;
